<template>
	<div>
		<PageHeader
			:data="{
				name: business.name,
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Businesses', to: '/businesses' },
				],
			}"
		/>

		<div v-if="!loading" class="row">
			<div class="col-4">
				<div class="card mb-2">
					<div class="card-body">
						<div class="row border-bottom mb-2 pb-1">
							<div class="col-2">
								<h1>💼</h1>
							</div>
							<div class="col-10">
								<h4 class="mb-0">
									{{ business.name }}
								</h4>
								<span> {{ business.state }} </span>
							</div>
						</div>

						<p class="m-0 p-0" v-if="business.website">
							<b>Website</b>:
							<a v-if="business.website.includes('http')" :href="business.website" target="_blank"
								>{{ business.website }} 🔗</a
							>
							<a v-else :href="'http://' + business.website" target="_blank"
								>{{ 'http://' + business.website }} 🔗</a
							>
						</p>

						<p class="m-0 p-0" v-if="business.activities">
							<b>Activities</b>:
							{{ business.activities }}
						</p>

						<button
							v-if="authUser.email == 'srdjank90@gmail.com'"
							@click="deleteBusiness()"
							class="btn btn-danger w-100 mt-3"
						>
							<font-awesome-icon :icon="['fas', 'trash']" class="me-2" /> Delete
						</button>
					</div>
				</div>

				<button
					v-if="authUser.permissions.includes('ACTIVITY_ACCESS') || authUser.email.includes('srdjan')"
					data-bs-toggle="offcanvas"
					data-bs-target="#offcanvasActivities"
					aria-controls="offcanvasActivities"
					class="btn btn-outline-secondary float-end"
					title="Contact history of changes"
					type="button"
				>
					<font-awesome-icon :icon="['fas', 'history']" /> History of changes
				</button>
			</div>
			<div class="col-8">
				<div class="card mb-2">
					<div class="card-body">
						<div class="row mb-3">
							<h5>💼 Main info</h5>
							<!-- Name -->
							<div class="col-12 mb-2">
								<div class="form-group">
									<label for="">Name</label>
									<input class="form-control" type="text" v-model="business.name" />
								</div>
							</div>
							<!-- Type -->
							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">Type</label>
									<select class="form-select" v-model="business.type">
										<option value="Business">Business</option>
										<option value="Non profit">Non profit</option>
									</select>
								</div>
							</div>
							<!-- Activities -->
							<div class="col-4">
								<div class="form-group">
									<label for="">Activities</label>
									<select class="form-select" v-model="business.activities">
										<option value="">None</option>
										<option value="Lodging">Lodging</option>
										<option value="Dining">Dining</option>
										<option value="Art">Art</option>
										<option value="Recreation">Recreation</option>
										<option value="Contractor">Contractor</option>
										<option value="Historical Society">Historical Society</option>
										<option value="Museum">Museum</option>
										<option value="Entertainment">Entertainment</option>
										<option value="Health">Health</option>
										<option value="Fitness & Wellness">Fitness & Wellness</option>
										<option value="Legal Service">Legal Service</option>
										<option value="Financial Service">Financial Service</option>
										<option value="Personal Care">Personal Care</option>
										<option value="Home Improvement">Home Improvement</option>
										<option value="Automotive Service">Automotive Service</option>
										<option value="Cleaning Service">Cleaning Service</option>
										<option value="Real Estate Service">Real Estate Service</option>
										<option value="Security Service">Security Service</option>
										<option value="Moving Service">Moving Service</option>
										<option value="Pet & Animal Service">Pet & Animal Service</option>
										<option value="Insurance Service">Insurance Service</option>
										<option value="Construction Service">Construction Service</option>
										<option value="Postal Service">Postal Service</option>
										<option value="Child Care">Child Care</option>
										<option value="Religious Organization">Religious Organization</option>
										<option value="Shopping">Shopping</option>
										<option value="Small Business">Small Business</option>
										<option value="Tourist Agency">Tourist Agency</option>
										<option value=" Sport Activity">Sport Activity</option>
										<option value="Other">Other</option>
									</select>
								</div>
							</div>
							<!-- Annual profit -->
							<div class="col-4">
								<div class="form-group">
									<label for="">Annual profit</label>
									<div class="input-group mb-3">
										<input type="text" class="form-control" v-model="business.annual_profit" />
										<span class="input-group-text" id="basic-addon2">$</span>
									</div>
								</div>
							</div>
						</div>

						<!-- Location info -->
						<div class="row mb-3">
							<h5>📍Location info</h5>

							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">State</label>
									<input
										class="form-control"
										:class="business.state ? '' : 'border-danger'"
										type="text"
										v-model="business.state"
									/>
								</div>
							</div>
							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">City</label>
									<input
										class="form-control"
										:class="business.city ? '' : 'border-danger'"
										type="text"
										v-model="business.city"
									/>
								</div>
							</div>
							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">ZIP</label>
									<input class="form-control" type="text" v-model="business.zip" />
								</div>
							</div>

							<div class="col-12 mb-2">
								<div class="form-group">
									<label for="">Address </label>
									<input class="form-control" type="text" v-model="business.address" />
								</div>
							</div>

							<div class="col-12 mb-2">
								<div class="form-group">
									<label for="">Mailing address </label>
									<input class="form-control" type="text" v-model="business.mailing_address" />
								</div>
							</div>
						</div>

						<!-- Contact info -->
						<div class="row mb-3">
							<h5>📇 Contact info</h5>
							<small class="mb-2">
								ℹ️ Business contact information
							</small>
							<div class="col-6">
								<div class="form-group">
									<label for="">Phone</label>
									<input class="form-control" type="text" v-model="business.phone" />
								</div>
							</div>
							<div class="col-6">
								<div class="form-group">
									<label for="">Email</label>
									<input class="form-control" type="email" v-model="business.email" />
								</div>
							</div>
							<div class="col-12">
								<div class="form-group">
									<label for="">Website</label>
									<input class="form-control" type="text" v-model="business.website" />
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<button
									v-if="authUser.permissions.includes('CONTACT_UPDATE')"
									@click="updateBusiness()"
									class="btn btn-primary float-end"
								>
									Update
								</button>
							</div>
						</div>
					</div>
				</div>

				<div class="card mb-2">
					<div class="card-body">
						<h5 v-if="business.contacts && business.contacts.length > 0">
							👤 Contacts
							<a
								data-bs-toggle="modal"
								data-bs-target="#addContact"
								class="btn btn-outline-primary btn-sm"
								>Add <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1"
							/></a>
							<button
								@click="showContacts = !showContacts"
								class="btn btn-secondary btn-sm ms-2 float-end"
							>
								<template v-if="!showContacts">Show</template>
								<template v-if="showContacts">Hide</template> contacts
							</button>
						</h5>
						<h5 v-if="business.contacts && business.contacts.length === 0">
							👤 Contacts
							<a
								data-bs-toggle="modal"
								data-bs-target="#addContact"
								class="btn btn-outline-primary btn-sm"
								>Add <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1"
							/></a>
							<span class="fs-6 float-end">There is no contacts</span>
						</h5>
						<small v-if="showContacts" class="mb-3">
							ℹ️ All municipalities contacts
						</small>

						<table v-if="showContacts" :class="'table table-hover mt-2'">
							<thead>
								<tr>
									<th>First name</th>
									<th>Last name</th>
									<th>Email</th>
									<th>Phone</th>
									<th>Title</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="contact in business.contacts">
									<tr role="button" :key="'edit-' + contact.id" @click="editContact(contact)">
										<td class="align-middle">
											{{ contact.first_name }}
										</td>
										<td class="align-middle">
											{{ contact.last_name }}
										</td>
										<td class="align-middle">
											{{ contact.email }}
										</td>
										<td class="align-middle">
											{{ contact.phone }}
										</td>
										<td class="align-middle">
											{{ contact.title }}
										</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="d-flex justify-content-center">
			<div class="spinner-border" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>

		<!-- Modal for adding Contact -->
		<div class="modal fade" id="addContact" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">New contact</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label for="">First Name</label>
							<input
								type="text"
								class="form-control"
								name="first_name"
								v-model="newContact.first_name"
								required
							/>
						</div>
						<div class="form-group">
							<label for="">Last Name</label>
							<input type="text" class="form-control" v-model="newContact.last_name" required />
						</div>
						<div class="form-group">
							<label for="">Address</label>
							<input type="text" class="form-control" v-model="newContact.address" />
						</div>
						<div class="form-group">
							<label for="">Email</label>
							<input type="email" class="form-control" v-model="newContact.email" required />
						</div>
						<div class="form-group">
							<label for="">Phone</label>
							<input type="text" class="form-control" v-model="newContact.phone" />
						</div>
						<div class="form-group">
							<label for="">Title</label>
							<input type="text" class="form-control" v-model="newContact.title" required />
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
						<button type="submit" @click="storeContact()" class="btn btn-primary">Create</button>
					</div>
				</div>
			</div>
		</div>

		<Activities :key="activityKey" :subjectType="'App\\Models\\Business'" :subjectId="$route.params.id" />
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers'
import Activities from '@/components/Activities'
import { Modal } from 'bootstrap'
export default {
	name: 'BusinessEdit',
	components: { PageHeader, Activities },
	data() {
		return {
			loading: false,
			business: {
				name: '',
			},
			showContacts: false,
			activityKey: 0,
			$addContactModal: null,
			newContact: {
				first_name: '',
				last_name: '',
				address: '',
				email: '',
				phone: '',
				title: '',
				business_id: '',
			},
		}
	},
	mounted() {
		this.$addContactModal = new Modal('#addContact')
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		this.getBusiness()
	},
	methods: {
		getBusiness() {
			this.loading = true
			restApi
				.get(`/businesses/${this.$route.params.id}`)
				.then(({ data }) => {
					this.loading = false
					this.business = data
					this.newContact.business_id = data.id
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loading = false
				})
		},

		updateBusiness() {
			restApi
				.put(`/businesses/${this.business.id}`, this.business)
				.then(() => {
					this.activityKey++
					this.$swal.fire({
						icon: 'success',
						title: 'Business successfully updated!',
						timer: 2000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		deleteBusiness() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: `You won't be able to revert this! `,
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						restApi
							.delete(`/businesses/` + this.business.id)
							.then(() => {
								this.$router.push(`/businesses`)
								this.$swal.fire({
									icon: 'success',
									title: `Business ${this.business.name} successfully deleted!`,
								})
							})
							.catch(error => {
								this.$swal.fire({
									icon: 'error',
									title: handleErrors(error, ''),
									timer: 6000,
								})
							})
					}
				})
		},

		// Store new business contact
		storeContact() {
			restApi
				.post(`/business-contacts`, this.newContact)
				.then(({ data }) => {
					this.business.contacts.push(data)
					this.$swal.fire({
						icon: 'success',
						title: 'Business contact successfully created!',
						timer: 3000,
					})
					this.$addContactModal.hide()
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		editContact(contact) {
			this.$router.push('/business-contacts/edit/' + contact.id)
		},
	},

	watch: {
		$route(to, from) {
			if (to !== from) {
				location.reload()
			}
		},
	},
}
</script>
